<template>
  <common-dialog ref="dialog" width="550px" title="添加发货地址" id-key="id" :data="data" @opened="onOpened"
    @create-opened="onCreateOpened" @edit-opened="onEditOpened" :form-rules="rules" :save-func="saveDataFunc"
    @closed="onClosed" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="寄件人" prop="senderAddress.fullName">
        <el-input v-model="data.senderAddress.fullName" placeholder="请输入寄件人"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="senderAddress.mobilePhone">
        <el-input v-model="data.senderAddress.mobilePhone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-checkbox v-model="data.senderAddress.dataMasking">打印发件人手机号脱敏显示，例如：13*********34</el-checkbox>
      </el-form-item> -->
      <!-- <el-form-item label="固定号码" prop="固定号码">
        <el-input v-model="data.固定号码" placeholder="请输入固定号码"></el-input>
      </el-form-item> -->
      <el-form-item label="快递公司" prop="wpCode">
        <div class="companies-select">
          <el-select v-model="data.wpCode" placeholder="请选择" @change="onCompaniesChange">
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.logisticsCompany" :value="i.code"></el-option>
          </el-select>
          <el-button class="refresh-btn" icon="el-icon-refresh" @click="fetchCompanies"></el-button>
        </div>
      </el-form-item>
      <el-form-item label="发货地址" prop="address">
        <el-select v-model="data.address" placeholder="请选择" @change="onAddressChange">
          <el-option v-for="(i, k) in senderAddresses" :key="k" :label="i.name" :value="i.name"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="省市区" prop="省市区">
        <address-select style="width: 100%;" v-model="data.省市区" :placeholder="'请选择城市'" @change="onAddressSelect">
        </address-select>
      </el-form-item> -->
      <el-form-item label="所属店铺" prop="所属店铺">
        <el-select :disabled="isEdit" v-model="mallId" @change="onMallChange" placeholder="请选择">
          <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.mallId"></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button type="warning" @click="reset">重 置</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      pddApi: {
        malladdresses: require('@/api/pdd/malladdresses').default,
        logistics: require('@/api/pdd/logistics').default,
      },
      sysType: "",
      mallId: "", //店铺Token
      data: {
        id: 0,
        wpCode: "", //快递公司Code
        logisticsId: "",
        logisticsCompany: "",
        address: "",
        senderAddress: {
          country: "",
          province: "",
          city: "",
          district: "",
          street: "",
          detailAddress: "",
          postalCode: "",
          fullName: "",
          mobilePhone: "",
          dataMasking: false, //数据脱敏
        },
      },
      initData: {},
      rules: {
        wpCode: [{ required: true, message: '请选择快递公司' }],
        'senderAddress.fullName': [{ required: true, message: '寄件人不能为空' }],
        'senderAddress.mobilePhone': [{ required: true, message: '手机号码不能为空' }],
        address: [{ required: true, message: '请选择发货地址' }],
      },
      companiesList: [],
      senderAddresses: [],
    };
  },
  computed: {
    mallList() {
      return this.$store.state.user.mallList.filter(x => x.day >= 0);
    }
  },
  mounted() { },
  methods: {
    onOpened() {
      console.log("onOpened")
      this.sysType = localStorage.getItem("sys_type");
      var user_info = localStorage.getItem("user-info");
      if (user_info) {
        let user = JSON.parse(user_info);
        let malls = this.$store.state.user.mallList.filter(x => x.day >= 0 && x.mallId == user.mallId);
        if (malls.length > 0) this.mallId = malls[0].mallId;
      }
    },
    onCreateOpened() {
      this.isEdit = false;
      this.initData = { ...JSON.parse(JSON.stringify(this.data)) };
      this.getCompanies();
    },
    onEditOpened() {
      this.isEdit = true;
      console.log("onEditOpened", JSON.parse(JSON.stringify(this.data)))
      var x = this.data.senderAddress;
      this.data.address = x.country + x.province + x.city + x.district + x.detailAddress;
      this.initData = { ...JSON.parse(JSON.stringify(this.data)) }
      this.getCompanies().then(res => {
        let loading = this.$loading({
          lock: true,
          text: "正在查询地址...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        this.getAddress(this.data.wpCode).then(res => {
          loading.close();
        }).catch((err) => {
          loading.close();
        })
      })
    },
    onMallChange() {
      this.data.wpCode = "";
      this.data.address = "";
      this.senderAddresses = [];
      this.companiesList = [];
      this.$refs.dialog.clearValidate();
      this.getCompanies();
    },
    fetchCompanies() {
      this.$refs.dialog.isLoading = true;
      this[this.sysType + "Api"].logistics.fetchCompanies().then(res => {
        this.$refs.dialog.isLoading = false;
        this.getCompanies();
      }).catch(error => {
        this.$refs.dialog.isLoading = false;
      })
    },
    getCompanies() {
      return new Promise((resolve, reject) => {
        this.$refs.dialog.isLoading = true;
        this[this.sysType + "Api"].logistics.companies(this.mallId).then(res => {
          this.$refs.dialog.isLoading = false;
          if (!res.errorCode) {
            this.companiesList = res.data;
          } else {
            this.$message.error(res.errorMessage);
          }
          resolve(res)
        }).catch((err) => {
          this.$refs.dialog.isLoading = false;
          reject(err)
        })
      });
    },
    onCompaniesChange(code) {
      this.senderAddresses = [];
      if (code) {
        var companies = this.companiesList.find(x => x.code == code);
        this.data.logisticsId = companies.logisticsId;
        this.data.logisticsCompany = companies.logisticsCompany;
        this.data.address = "";
        this.$refs.dialog.clearValidate();
        let loading = this.$loading({
          lock: true,
          text: "正在查询地址...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        this.getAddress(code).then(res => {
          loading.close();
        }).catch((err) => {
          loading.close();
        })
      }
    },
    getAddress(code) {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.senderaddresses(code, this.mallId).then(res => {
          if (!res.errorCode) {
            this.senderAddresses = res.data.map(x => {
              return { name: x.country + x.province + x.city + x.district + x.detailAddress, data: x }
            });
          } else {
            this.$message.error(res.errorMessage);
          }
          console.log("this.senderAddresses", this.senderAddresses)
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
    onAddressChange(e) {
      console.log("change", e);
      var addr = this.senderAddresses.find(x => x.name == e);
      console.log("addr", addr);
      this.data.senderAddress.country = addr.data.country;
      this.data.senderAddress.province = addr.data.province;
      this.data.senderAddress.city = addr.data.city;
      this.data.senderAddress.district = addr.data.district;
      this.data.senderAddress.detailAddress = addr.data.detailAddress;
    },
    // onAddressSelect(e) {
    //   this.data.省市区文本 = e.map(x => x.label).join("/");
    //   console.log("111", e);
    //   console.log("222", this.data.省市区);
    //   console.log("333", this.data.省市区文本);
    // },
    reset() {
      if (this.$refs.dialog.isLoading) {
        this.$message.warning("正在加载中，请稍候");
        return;
      }
      console.log("重置", this.initData);
      this.data = { ...this.initData }
      this.$refs.dialog.isChange = false;
      this.$refs.dialog.clearValidate();
      if (this.data.id != 0) {
        this.getCompanies().then(res => {
          let loading = this.$loading({
            lock: true,
            text: "正在查询地址...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.getAddress(this.data.wpCode).then(res => {
            loading.close();
          }).catch((err) => {
            loading.close();
          })
        })
      }
    },
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        var func = this[this.sysType + "Api"].malladdresses.postSender;
        if (this.data.id != 0) {
          func = this[this.sysType + "Api"].malladdresses.putSender;
        }
        func(this.data).then(res => {
          if (res) {
            resolve({ Code: 1, Msg: res.errorMessage })
          } else {
            resolve({ Code: 0, Msg: null })
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    onClosed() {
      var resetData = this.$options.data().data;
      this.data = { ...resetData }
      this.companiesList = [];
      this.senderAddresses = [];
      this.$refs.dialog.clearValidate();
    }
  },
};
</script>
<style lang="scss" scoped>
.companies-select {
  display: flex;

  .el-select {
    width: calc(100% - 55px);
  }

  .refresh-btn {
    margin-left: 5px;
    width: 50px;
    border-radius: 4px;
  }
}
</style>